import styles from 'partials/dashboard/user-sidebar.module.scss';
import { NavLink } from 'react-router-dom';

export const UserSidebarItem = ({ title, icon, linkUrl }) => {
	const Icon = icon;
	return (
		<li className={styles.list}>
			<NavLink
				exact
				to={linkUrl}
				className={styles.listItem}
				activeClassName={styles.activeItem}>
				<Icon size="24" className={styles.listIcon} />
				{title}
			</NavLink>
		</li>
	);
};
